// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","container":"AgentCard_container__AyKfb","break":"AgentCard_break__4C6-v"};